// @flow
import { createParser, fields } from '../utils/parse';

export const FilterValue = createParser('FilterValue', {
  // Optional Parameters
  featured: fields.bool(false),
  remove: fields.bool(false),
  rgb: fields.string(''),

  // Required Parameters
  name: fields.string(''),
  on: fields.bool(false),
  type: fields.string(''),
  value: fields.string('', {
    transform: value => (typeof value !== 'undefined' ? value.toString() : ''),
  }),
});

export const FilterGroups = createParser('FilterGroups', {
  values: fields.array(FilterValue, { path: 'filter_values' }),
  name: fields.string(''),
  slug: fields.string(''),
});

export default FilterGroups;
